export default __webpack_public_path__ + "static/media/img-id-photo@3x.cbcb1dca.png";